import React, { useState } from "react";

import Suggestion from "./Suggestion/Suggestion";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles(() => ({
  suggestionContainer: {
    cssFloat: "left",
    width: "stretch",
    marginTop: "5px",
  },
}));

const NUMBER_OF_SUGGESTIONS_TO_SHOW = 5;

const showMore = (suggestions, numberOfSuggestionsToShow) =>
  numberOfSuggestionsToShow < suggestions.length - 1;

export default ({
  suggestions,
  handleClick,
  customWidgetStyle,
  disableShowMoreSuggestions,
}) => {
  const [numberOfSuggestionsToShow, setNumberOfSuggestionsToShow] = useState(
    disableShowMoreSuggestions
      ? suggestions.length
      : NUMBER_OF_SUGGESTIONS_TO_SHOW
  );
  const styles = useStyles();

  return (
    <div className={styles.suggestionContainer}>
      {suggestions
        .slice(
          0,
          showMore(suggestions, numberOfSuggestionsToShow)
            ? numberOfSuggestionsToShow
            : numberOfSuggestionsToShow + 1
        )
        .map((suggestion, index) => (
          <Suggestion
            key={index}
            handleClick={() => handleClick(suggestion)}
            displayText={suggestion.displayText}
            customWidgetStyle={customWidgetStyle}
            isExternalLink={!!suggestion.url}
          />
        ))}
      {showMore(suggestions, numberOfSuggestionsToShow) && (
        <Suggestion
          displayText={"Show more"}
          handleClick={() =>
            setNumberOfSuggestionsToShow(
              numberOfSuggestionsToShow + NUMBER_OF_SUGGESTIONS_TO_SHOW
            )
          }
          customWidgetStyle={customWidgetStyle}
        />
      )}
    </div>
  );
};
